import createUrlBuilder from 'utilities/url.builder.utils';
import { getFetchRequest, getRequest } from 'utilities/service.utils';
import AppService from './app.service.context';
import AppReportingService from './reports.service.context';
import { ReportsApiParamsTypes } from 'types';

export const getJRSToken = async () => {
  const urlBuilder = createUrlBuilder(`/system/reporting/token`);
  const response = await getRequest(AppService, urlBuilder.toString());
  return response;
};

/*
 * Params
 *           token: each report has unqiue token for sub-sequent calls
 */
export const fetchReportListService = async () => {
  const urlBuilder = createUrlBuilder(
    `/jasperserver-pro/rest_v2/resources?recursive=true&type=reportUnit&limit=0`
  ).toString();
  const response = await getFetchRequest(AppReportingService, urlBuilder);
  return response;
};

/*
 * Paramamers
 *           token: each report has unqiue token for sub-sequent calls
 *           systemAdminName: default is 'System_Admin_Dummy'
 */
export const fetchReportInputControls = async (
  payload: ReportsApiParamsTypes
) => {
  const { reportUrl } = payload;
  const urlBuilder = createUrlBuilder(
    `/jasperserver-pro/rest_v2/reports${reportUrl}/inputControls`
  ).toString();
  const response = await getFetchRequest(AppReportingService, urlBuilder);
  return response;
};
/*
 * Paramamers
 *           timezone: Default is 'Australia/Sydney'
 */
export const loadVisualizeJS = async (timezone: string) => {
  const existingScript = document.getElementById('visualizejs');
  if (!existingScript) {
    const reportingServerUrl = process.env.REACT_APP_REPORTING_SERVER_URL;
    const commonVisualizejsUrl = `${reportingServerUrl}/jasperserver-pro/client/visualize.js`;
    const script = document.createElement('script');
    script.src = `${
      process.env.REACT_APP_JASPER_VISUALIZE_JS_URL || commonVisualizejsUrl
    }?userTimezone=${timezone}`;
    script.id = 'visualizejs';
    document.body.appendChild(script);
  }
};
